
/**
 * 登录缓存key
 */
export let userLoginSessionKey

/**
 * 设置登录缓存key
 * @param {*} value
 */
export function setUserLoginSessionKey(value) {
  userLoginSessionKey = value
}


// 登录用户信息
export const user = {
  TenantId: 0,
  TenantName: 'none',
  BranchCode: '00000000',
  BranchId: 0,
  BranchName: 'none',
  OperId: 0,
  OperName: 'none',
  BranchType: 'Z', // 门店类型：总店
  TenantType: 14,
  isHeadquarters: false // 是否为总部门店
}

/**
 * 设置当前用户信息
 * @param {*} data
 */
export function setCurrentUser(data) {
  Object.assign(user, data)
  user.isHeadquarters = data.TenantType === 'Z'
}

